import { TextPreviewItem as LMFTextPreviewItem } from '@syconium/little-miss-figgy'

import { EmbroideryService } from '../../../../containers/EmbroideryService'
import { TextFormValues } from '../../../../containers/EmbroideryService/types'
import { isSufficientEmbroideryColorContrast } from '../../../../containers/EmbroideryService/utils'
import { EmbroideryPlacementOffset } from '../../../../types/graphql'
import { colorMap } from '../selectors/ColorSelector'

export const TextPreviewItem = <T extends Omit<TextFormValues, '__type'>>({
  values,
}: {
  values: T
}) => {
  const { productColorHex } = EmbroideryService.useContainer()

  const isSufficientColorContrast = values.textColor
    ? isSufficientEmbroideryColorContrast(
        productColorHex,
        '#' + colorMap[values.textColor].hexCodes[0]
      )
    : undefined
  const { backgroundImage } = EmbroideryService.useContainer()

  const backgroundImageOffsetsByKey: Record<string, EmbroideryPlacementOffset> =
    backgroundImage?.embroideryOffsets || {}

  const backgroundImageOffsets: EmbroideryPlacementOffset | undefined =
    values.textPlacement && backgroundImageOffsetsByKey[values.textPlacement.offsetKey ?? '']

  const xOffset: string | undefined = backgroundImageOffsets?.x
  const yOffset: string | undefined = backgroundImageOffsets?.y
  const rotation: number | undefined = backgroundImageOffsets?.rotation
  const scale: number | undefined = backgroundImageOffsets?.scale

  if (!values.textPlacement) return null

  return (
    <LMFTextPreviewItem
      color={values.textColor ?? ''}
      firstLine={values.firstLine}
      fontSizeRatio={values.font?.scale}
      fontStyle={values.font?.name ?? ''}
      rotation={rotation}
      scale={scale}
      secondLine={values.secondLine}
      xOffset={xOffset}
      yOffset={yOffset}
      warning={!isSufficientColorContrast}
    />
  )
}
